module.exports = __webpack_public_path__ + "fonts/DM_Sans-500-latin-ext10.49935c4.woff2";